import { v4 as uuidv4 } from 'uuid';
import ResumeBuilder from './components/Assets/Resume Builder(Nest Hub Max).png';
import Rentals from './components/Assets/localhost_3000_(Nest Hub Max).png';
import EasyWeb from './components/Assets/williams(Nest Hub Max).png';


const Data = [{
        id: uuidv4(),
        name: 'resume builder',
        introdesc: 'Resume builder generates resume templates with thousands ........',
        desc: 'Resume builder generates resume templates with thousands of perfectly written bullet points for you to choose from, covering all industries. Just point and click the relevant job description bullet points. No registration required! No matter who you are, our Resume Builder will automatically format them onto your favorite resume templates.',
        imgUrl: ResumeBuilder,
        "stack ": {
            "state": "Context Api",
            "backend": "Firebase",
            "frontend": "React Js",
            "styling": "Bootstrap"
        },
        imgAlt: 'Project One',
        viewDemo: "https://theresumebuilder.netlify.app"
    },
    {
        id: uuidv4(),
        name: 'rentals',
        introdesc: 'Rentals is designed to help you during your rental journey........',
        desc: ' Rentals is an aplication that is designed to help  demonstrates a renting website using the react js framework. Rentals provides a selection of a product in the aplication from firestore database and displays them for rent. Users can select to display products in single category, click on any product to get more information including ratings, description, reviews , rentals has a built in timing system which is triggered onces the user completes his/her paymment using paystack',
        imgUrl: Rentals,
        imgAlt: 'Project Two',
        "stack ": {
            "state": "Redux {...otherReduxLibaries}",
            "backend": "Firebase",
            "frontend": "React Js",
            "styling": "Tailwind Css"
        },
        viewDemo: "https://letsrentit.netlify.app"
    }, {
        id: uuidv4(),
        name: 'easy web',
        introdesc: 'Easy Web is a specialized theme in the field of web templates.......',
        desc: 'Easy Web is a specialized theme in the field of web templates. it is loaded with fully-practical real content that lets you start you website in a couple of minutes. its a clean and simple interface to organize your favourite websites. Open a new browser tab and see your sites load instantly. Try it for free.',
        imgUrl: EasyWeb,
        imgAlt: 'Project Three',
        "stack ": {
            "state": "Context Api",
            "backend": "Firebase",
            "frontend": "React Js",
            "styling": "Tailwind Css"
        },
        viewDemo: "https://easyweb-V2.netlify.app"
    }
];

export default Data;

export function getProject(title) {
    return Data.find(
        (projects) => projects.name === title
    );
}